import * as Yup from 'yup'

import { SERVER_NON_FIELD_ERROR_KEY } from '../../../constants/validation'

import {
  APPOINTMENT_FORM_FIELD_NAME,
  APPOINTMENT_FORM_LOCATION_MAX_LENGTH,
  APPOINTMENT_FORM_SPAN_ERROR_KEY,
  APPOINTMENT_FORM_TITLE_MAX_LENGTH,
} from './AppointmentFormModal.constants'
import { getIsAppointmentFormSpanInvalid } from './AppointmentFormModal.utils'

function getAppointmentFormDateSchema(isAllDay) {
  return Yup.date()
    .nullable()
    .when(APPOINTMENT_FORM_FIELD_NAME.isAllDay, {
      is: isAllDay,
      then: schema => schema.required(true),
    })
}

function getAppointmentFormSpanEndSchema({ isAllDay, t }) {
  return Yup.date()
    .nullable()
    .when(APPOINTMENT_FORM_FIELD_NAME.isAllDay, {
      is: isAllDay,
      then: schema =>
        schema.required(true).test({
          message: t(APPOINTMENT_FORM_SPAN_ERROR_KEY),
          name: 'appointmentFormSpanEnd',
          test: (value, context) =>
            !getIsAppointmentFormSpanInvalid(context.parent),
        }),
    })
}

export function getAppointmentFormSubmitErrors(t) {
  return {
    [SERVER_NON_FIELD_ERROR_KEY]: t('Appointment.FormSaveErrorKey'),
  }
}

export function getAppointmentFormValidationSchema(t) {
  return Yup.object({
    [APPOINTMENT_FORM_FIELD_NAME.end]: getAppointmentFormSpanEndSchema({
      isAllDay: false,
      t,
    }),
    [APPOINTMENT_FORM_FIELD_NAME.firstDay]: getAppointmentFormDateSchema(true),
    [APPOINTMENT_FORM_FIELD_NAME.lastDay]: getAppointmentFormSpanEndSchema({
      isAllDay: true,
      t,
    }),
    [APPOINTMENT_FORM_FIELD_NAME.location]: Yup.string().max(
      APPOINTMENT_FORM_LOCATION_MAX_LENGTH
    ),
    [APPOINTMENT_FORM_FIELD_NAME.start]: getAppointmentFormDateSchema(false),
    [APPOINTMENT_FORM_FIELD_NAME.title]: Yup.string()
      .trim()
      .max(APPOINTMENT_FORM_TITLE_MAX_LENGTH)
      .required(true),
  })
}
